module.exports = __webpack_public_path__ + "6c23157ddd2d553fbd7c4dca9ccf7e1b.mp3";